export default __webpack_public_path__ + "static/media/grinScopeLGInfo.cac59975.png";